import { Component, Input, OnInit, Type, ViewChild, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { EquityElementTypeEnum } from '@coin/shared/core/util-enums';
import { EquityPageDataDirective } from '../../directives/equity-page-data.directive';
import { EquityPageComponentModel } from '../../models/equity-page-component.model';
import { EquityCardsComponent } from '../equity-cards/equity-cards.component';
import { EquityHeadlineComponent } from '../equity-headline/equity-headline.component';
import { EquityMediaComponent } from '../equity-media/equity-media.component';
import { EquitySubTitleComponent } from '../equity-sub-title/equity-sub-title.component';
import { EquityTextComponent } from '../equity-text/equity-text.component';
import { EquityTilesComponent } from '../equity-tiles/equity-tiles.component';
import { EquityPageDataService } from '../../services/equity-page-data.service';
import { DynamicSpacerComponent } from '../dynamic-spacer/dynamic-spacer.component';
import { EquityCountryInfoComponent } from '../equity-country-info/equity-country-info.component';
import { EquityDownloadComponent } from '../equity-download/equity-download.component';
import { EquityElementNotFoundComponent } from '../equity-element-not-found/equity-element-not-found.component';
import { NgStyle } from '@angular/common';
import { EquityChapterIconComponent } from '../equity-chapter-icon/equity-chapter-icon.component';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { V2ButtonComponent } from '@coin/shared/core/ui-storybook';

@Component({
  selector: 'customer-app-equity-chapter',
  templateUrl: './equity-chapter.component.html',
  styleUrls: ['./equity-chapter.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgStyle, EquityChapterIconComponent, MatSlideToggle, FormsModule, V2ButtonComponent, TranslatePipe]
})
export class EquityChapterComponent implements OnInit {
  equityPageDataService = inject(EquityPageDataService);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() chapter: any;
  readonly showPrint = input<boolean>(undefined);
  @ViewChild(EquityPageDataDirective, { static: true }) equityPageDataHost: EquityPageDataDirective;

  isRow = false;

  ngOnInit(): void {
    this.loadComponents();
    this.getRowState();
  }

  loadComponents(): void {
    if (this.chapter?.elements.length) {
      for (const element of this.chapter.elements) {
        const matchingComponent = this.getMatchingComponentInstance(element.type);
        this.appendElementToDom(matchingComponent, element);
      }
    }
  }

  private appendElementToDom(component: Type<unknown>, data: unknown): void {
    const { viewContainerRef } = this.equityPageDataHost;
    const componentRef = viewContainerRef.createComponent(component);

    if (data) {
      (<EquityPageComponentModel>componentRef.instance).data = data;
    }
  }

  private getRowState(): void {
    this.isRow = this.equityPageDataService.getRowState();
  }

  toggleROW(): void {
    this.equityPageDataService.toggleROW();
  }

  print(): void {
    window.print();
  }

  private getMatchingComponentInstance(type: EquityElementTypeEnum): Type<unknown> {
    switch (type) {
      case EquityElementTypeEnum.HEADLINE:
        return EquityHeadlineComponent;
      case EquityElementTypeEnum.SUB_TITLE:
        return EquitySubTitleComponent;
      case EquityElementTypeEnum.TEXT:
        return EquityTextComponent;
      case EquityElementTypeEnum.MEDIA:
        return EquityMediaComponent;
      case EquityElementTypeEnum.TILES:
        return EquityTilesComponent;
      case EquityElementTypeEnum.CARDS:
        return EquityCardsComponent;
      case EquityElementTypeEnum.SPACER:
        return DynamicSpacerComponent;
      case EquityElementTypeEnum.COUNTRY_INFO:
        return EquityCountryInfoComponent;
      case EquityElementTypeEnum.DOWNLOAD:
        return EquityDownloadComponent;
      default:
        return EquityElementNotFoundComponent;
    }
  }
}
